import React, { useContext } from 'react';
import { Divider } from '@mui/material';
import { Context as AuthContext } from '../../../contexts/authContext';
import { ChangePasswordForm } from '../../AccountPanel/ChangePasswordForm/ChangePasswordForm';
import { CardSettings } from './CardSettings';
import { APIKeysTable } from '../../AccountPanel/APIKeysTable/APIKeysTable';
import { TwoFactorAuth } from '../../AccountPanel/2FA/TwoFactorAuth';
import { MDTypography } from '../../MDTypography';

export default function ProfileBusiness() {
  const { user } = useContext(AuthContext);

  return (
    <div style={{ margin: '0 auto' }}>
      <MDTypography variant="h4" style={{ marginBottom: 6 }}>
        {`${user!.carrier?.displayName} Profile`}
      </MDTypography>
      <MDTypography variant="body1" component="span">
        <span style={{ fontWeight: 600 }}>User: </span>
        <MDTypography variant="body1" component="span" color="text">
          {user!.fullName}
        </MDTypography>
        {' | '}
      </MDTypography>
      <MDTypography variant="body1" component="span">
        <span style={{ fontWeight: 600 }}> User Role: </span>
        <MDTypography variant="body1" component="span" color="text">
          {user!.role}
        </MDTypography>
        {' | '}
      </MDTypography>
      <MDTypography variant="body1" component="span">
        <span style={{ fontWeight: 600 }}> Active since: </span>
        <MDTypography variant="body1" component="span" color="text">
          {new Date(user!.createdAt!).toLocaleDateString()}
        </MDTypography>
        {' | '}
      </MDTypography>
      <CardSettings />
      <div style={{ width: 'fit-content' }}>
        <Divider style={{ marginTop: 30, marginBottom: 40 }} />
        <MDTypography variant="subtitle1" style={{ fontWeight: 600 }}>
          API keys:
        </MDTypography>
        <div style={{ paddingBottom: 10 }}>
          <MDTypography variant="caption">
            The FairFare team will guide you on how and where you should install this API key.
          </MDTypography>
        </div>
        <APIKeysTable />
        <Divider style={{ marginTop: 30, marginBottom: 40 }} />
        <TwoFactorAuth />
        <Divider style={{ marginTop: 30, marginBottom: 40 }} />
        <MDTypography variant="h2" color="dark">Account Settings</MDTypography>
        <div style={{ marginTop: 20 }}>
          <ChangePasswordForm />
        </div>
        {/* <FormControl variant="outlined" style={{ marginTop: 16, marginBottom: 50, maxWidth: 350, display: 'flex' }} required fullWidth>
            <InputLabel id="lang-label">{t('Language')}</InputLabel>
            <Select labelId="lang-label" id="language" value={lang} onChange={(e: any) => changeLang(e.target.value)} label={t('Language')}>
              <MenuItem value="en">English</MenuItem>
              <MenuItem value="he">עברית</MenuItem>
            </Select>
          </FormControl> */}
        <Divider />
      </div>
      {/* <Grid item xs={12}></Grid>
      <Grid item xs={12}></Grid> */}
    </div>
  );
}
